import { faPlay } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { IMAGE, VIDEO } from '../../../../config/constants';
import ImageWithLoading from '../../../commonElements/imageWithLoading';

const ImageCard = ({ imageUrl, selected, selectImage }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div onClick={()=>{selectImage(imageUrl)}} className={`d-flex flex-column justify-content-center align-items-center position-relative rounded border border-white cursor-pointer ${selected && 'border border-success '}`}>
      {/* ✅ Checkbox */}
      <div
        className="position-absolute top-0 end-0 mt-4 me-4 bg-white  rounded shadow"
        style={{ zIndex: 10 }}
      >
        <input
          type="checkbox"
          checked={selected}
          // onChange={() => selectImage(imageUrl)}
          className="form-check-input m-0 p-1 cursor-pointer"
          style={{
            width: '20px',
            height: '20px'
          }}
        />
      </div>

      <div className="h-200px w-200px bg-white d-flex justify-content-center align-items-center rounded">
        <ImageWithLoading
          src={imageUrl}
          alt="placeholder"
          className="img-thumbnail h-200px w-200px"
          style={{ objectFit: 'cover' }}
        />
      </div>
    </div>
  );
};

export default ImageCard;
